import React, { useState } from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import * as Constants from '../../../../constants';
import { message } from 'antd';
import Search from 'antd/lib/input/Search';
import LoadingPage from '../../../components/LoadingPage';
import { db } from '../../../../config/Fire';
import moment from 'moment';
import './styles.css';
import SurveysSolvedTable from '../../../components/SurveysSolvedTable';

function compareDateHourSurveyByDate( a, b ) {
    const hourA = moment(a.solvedDate, 'HH:mm DD/MM/YYYY');
    const hourB = moment(b.solvedDate, 'HH:mm DD/MM/YYYY');
    if ( hourA.isAfter(hourB) ) {
      return 1;
    }
    if ( hourA.isBefore(hourB) ) {
      return -1;
    }
    return 0;
};

const SurveysStatistics = ({ props }) => {
    const[surveysSolved, setSurveysSolved] = useState(null)
    const[filterEmail, setFilterEmail] = useState("")

    const getSurveysSolved = () => {
        db.ref(`${Constants.MAIN_NODES.SURVEYS_SOLVED}`).once("value")
        .then((snapshot) => {
            if(snapshot.exists()) {
                var surveysSolvedMap = {}
                snapshot.forEach(surveySnap => {
                    const survey = surveySnap.val();
                    surveysSolvedMap[survey.id] = survey;
                });
                setSurveysSolved(surveysSolvedMap)
            } else {
                setSurveysSolved({})
            }
        })
        .catch(err => {
            console.log("Err: " + JSON.stringify(err))
            message.warning("Se produjo un error. Vuelva a intentarlo")
        });
        return <LoadingPage />
    }

    const renderSurveysSolvedTable = (array, filter) => {
        var data = []
        Object.values(array).forEach(value => {
            if(filter === "" || (value.userEmail && value.userEmail.includes(filter))) {
                data.push(value)
            }
        });
        data.sort(compareDateHourSurveyByDate)
        return <SurveysSolvedTable data={data}/>
    }

    return (
        <Grid className="surveysStatisticsCont">
            <Row center="xs">
                <Col xs={12}>
                    {
                        surveysSolved ?
                            <Row center="xs">
                                <Col xs={12} md={10} lg={6}>
                                    <Search className="searchSurveysSolved" placeholder="Buscar por correo electrónico" onSearch={(value) => setFilterEmail(value)} enterButton />
                                </Col>
                                <Col xs={12} md={11}>
                                    {renderSurveysSolvedTable(surveysSolved, filterEmail)}
                                </Col>
                            </Row>
                            :
                            getSurveysSolved()
                    }
                </Col>
            </Row>
        </Grid>
    )
}

export default SurveysStatistics;